import { formStoreLenses } from 'root/src/client/logic/form/lenses'

const { viewFieldLoading } = formStoreLenses

export default (state, { fieldId }) => (
	viewFieldLoading(fieldId, state)
)
